import { cloneElement, useEffect, useState } from 'react'
import type { MouseEventHandler, ReactElement } from 'react'
import { Tooltip } from 'antd'
import type { TooltipPlacement } from 'antd/es/tooltip'

import css from './ui.module.scss'

export const OperatorAvatarTooltip = ({avatar, name, accessLevel, children, placement = 'bottomRight', resetKey}: {
    avatar: string
    name: string
    accessLevel: string
    children: ReactElement<{onClick?: MouseEventHandler<HTMLElement>}>
    placement?: TooltipPlacement
    resetKey?: string | number
}) => {
    const [open, setOpen] = useState(false)

    useEffect(() => {setOpen(false)}, [resetKey])
    useEffect(() => {
        if (!open) return
        const closeOnEscape = (event: KeyboardEvent) => {
            if (event.key === 'Escape') setOpen(false)
        }
        document.addEventListener('keydown', closeOnEscape)
        return () => document.removeEventListener('keydown', closeOnEscape)
    }, [open])

    return <Tooltip placement={placement} trigger={['hover', 'focus']}
        open={open} onOpenChange={setOpen}
        mouseEnterDelay={0.2} mouseLeaveDelay={0.1} destroyOnHidden
        zIndex={900} getPopupContainer={() => document.body}
        color='var(--background_nav_panel)'
        classNames={{root: css.profile_tooltip, container: css.profile_tooltip_container}}
        title={<div className={css.profile_preview} onClick={event => event.stopPropagation()}>
            <img src={avatar} alt='Аватар оператора' width='144' height='144' />
            <span className={css.profile_preview_name}>{name}</span>
            <span className={css.profile_preview_access}>{accessLevel}</span>
        </div>}>
        {cloneElement(children, {onClick: event => {
            setOpen(false)
            children.props.onClick?.(event)
        }})}
    </Tooltip>
}
